import { Link, NavLink } from 'react-router-dom';
import { useEffect, useState } from "react";
import Form from 'react-bootstrap/Form';
import UserService from "../Services/UserService";
import PubSub from 'pubsub-js';
import { Tooltip } from 'react-tooltip';
import Dropdown from 'react-bootstrap/Dropdown';
import AuthService from '../Services/AuthService';

// Skeleton loader styles
const skeletonStyles = `
    .skeleton-checkbox, .skeleton-text, .skeleton-switch, .skeleton-dropdown {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: loading 1.5s infinite;
        border-radius: 4px;
    }
    
    @keyframes loading {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }

`;

function AdminListUsers() {

    let [users, setUsers] = useState([]);
    let [searchParam, setSearchParam] = useState('');
    let [filterAppPassword, setFilterAppPassword] = useState('all');
    let [filterCampaign, setFilterCampaign] = useState('all');
    let [filterPaused, setFilterPaused] = useState('all');
    let [filterRole, setFilterRole] = useState('all');
    let [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        getUsersRegistered();
    }, []);


    async function getUsersRegistered() {
        setIsLoading(true);
        PubSub.publish('loading.notification', { message: 'Loading users...', show: true });
        let users = await UserService.getUsersRegistered();
        PubSub.publish('loading.notification', { message: 'Loading users...', show: false });
        setUsers(users);
        setIsLoading(false);
    }

    async function revokeToken(email) {
        if (!window.confirm(`Are you sure you want to revoke the token for this user: ${email}?`)) {
            return;
        }

        let { message } = await AuthService.revokeTokenForEmail(email);
        PubSub.publish('show-basic-notification', {
            title: 'Token revoked',
            message: message
        });
    }

    function onClickOnSwitch(user) {
        user.paused = !user.paused;
        UserService.pauseUser(user._id, user.paused);
        setUsers([...users]);
        PubSub.publish('show-basic-notification', {
            title: 'User updated',
            message: `User has been ${user.paused ? 'paused' : 'unpaused'}`
        });
    }

    async function removeUser(user) {

        let confirmMessage = 'Are you sure you want to remove this user?, this action cannot be undone';

        if (!window.confirm(confirmMessage)) {
            return;
        }

        let { message } = await UserService.removeUser(user._id);
        setUsers(users.filter(u => u._id !== user._id));
        PubSub.publish('show-basic-notification', {
            title: 'User removed',
            message: message
        });
    }

    function renderAppPasswordStatus(app_password) {
        if (app_password && app_password?.length > 0) {
            return <i
                data-tooltip-id="users-registered-tooltip"
                data-tooltip-content="App password completed"
                class="far fa-check-circle ms-2 text-primary"></i>
        }
    }

    function renderAccessTokenIcon(access_token) {
        if (access_token) {
            return <i
                data-tooltip-id="users-registered-tooltip"
                data-tooltip-content="Access token available"
                class="fas fa-lock ms-2 text-primary"></i>
        }
    }

    function renderRefreshTokenIcon(refresh_token) {
        if (refresh_token) {
            return <i
                data-tooltip-id="users-registered-tooltip"
                data-tooltip-content="Refresh token available"
                class="fas fa-lock ms-2 text-primary"></i>
        }
    }

    function renderRoleIcon(role) {
        let iconClass = '';
        let tooltip = '';
        switch (role) {
            case 'admin':
                iconClass = 'fas fa-user-shield text-danger';
                tooltip = 'Admin user';
                break;
            case 'whitelist':
                iconClass = 'fas fa-user-clock text-warning';
                tooltip = 'Whitelisted user';
                break;
            default:
                iconClass = 'fas fa-user text-primary';
                tooltip = 'Regular user';
        }

        return <i
            data-tooltip-id="users-registered-tooltip"
            data-tooltip-content={tooltip}
            className={iconClass + ' ms-2'}></i>
    }

    function renderRoleDropdownText() {
        let text = 'User type';
        let icon = null;

        switch (filterRole) {
            case 'admin':
                text = 'Admin';
                icon = <i className="fas fa-user-shield text-danger me-2"></i>;
                break;
            case 'user':
                text = 'User';
                icon = <i className="fas fa-user text-primary me-2"></i>;
                break;
            case 'whitelist':
                text = 'Whitelist';
                icon = <i className="fas fa-user-clock text-warning me-2"></i>;
                break;
            default:
                icon = <i className="fas fa-filter me-2"></i>;
        }

        return (
            <span>
                {icon}
                {text}
            </span>
        );
    }


    function renderUsers() {

        let usersToRender = users.filter(u => {
            let matchesSearch = u.name.toLowerCase().includes(searchParam.toLowerCase()) ||
                u.email.toLowerCase().includes(searchParam.toLowerCase());
            if (searchParam && !matchesSearch) return false;

            if (filterAppPassword === 'yes' && !(u.app_password && u.app_password.length > 0)) return false;
            if (filterAppPassword === 'no' && (u.app_password && u.app_password.length > 0)) return false;

            if (filterCampaign === 'yes' && !(u.campaigns && u.campaigns.length > 0)) return false;
            if (filterCampaign === 'no' && (u.campaigns && u.campaigns.length > 0)) return false;

            if (filterPaused === 'yes' && !u.paused) return false;
            if (filterPaused === 'no' && u.paused) return false;

            if (filterRole !== 'all' && u.role !== filterRole) return false;

            return true;
        });

        return usersToRender.map((user, index) => (
            <div className="list-group" key={`user${index}`}>
                <div to={'/sequences/' + user._id}
                    className="sequence-list-item"
                    aria-current="true">

                    <Form.Check // prettier-ignore
                        type='checkbox'
                        id={`checkbox-${index}`}
                        className="checkbox me-3"
                        checked={user.selected}
                        onChange={() => {
                            user.selected = !user.selected;
                            setUsers([...users]);
                        }}
                        style={{ transform: 'scale(1.3)' }}
                    />


                    <Link to={'/admin/users/detail/' + user._id} className="w-100 pointer blank-link">
                        <div className="d-flex w-100 justify-content-between">
                            <p className="mb-1 bold fs-14">{user.name}
                                {renderRoleIcon(user.role)}

                                {renderAppPasswordStatus(user.app_password)}

                                {user?.campaigns?.length > 0 && (
                                    <span
                                        data-tooltip-id="users-registered-tooltip"
                                        data-tooltip-content={user.campaigns.map(c => c.name).join(', ')}
                                        className='badge bg-primary ms-2'>{user.campaigns.length} campaigns active</span>
                                )}

                            </p>
                        </div>
                        <small>
                            <span className="text-primary fs-12"> {user.email}</span>
                        </small>
                    </Link>

                    <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        className="mx-3"
                        onChange={() => onClickOnSwitch(user)}
                        checked={!user.paused}
                        style={{ transform: 'scale(1.3)' }}
                    />

                    <Dropdown>
                        <Dropdown.Toggle variant="muted"
                            className="no-chevron btn-sm" id="dropdown-basic">
                            <i className="fas fa-ellipsis-h"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {user.campaigns && user.campaigns.length > 0 && (
                                <Dropdown.Item as={Link} to={`/sequences/${user.campaigns[0]._id}`}>View sequence detail</Dropdown.Item>
                            )}
                            <Dropdown.Item onClick={() => removeUser(user)}>Remove</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>


                </div>

            </div>
        ))
    }

    function renderEmptyUsers() {
        return (
            <div className="d-flex justify-content-center align-items-center">
                <p className="fs-14">No users found</p>
            </div>
        )
    }

    function renderSkeletonLoader() {
        return Array.from({ length: 8 }).map((_, index) => (
            <div className="list-group" key={`skeleton-${index}`}>
                <div className="sequence-list-item">
                    <div className="skeleton-checkbox me-3" style={{ width: '16px', height: '16px' }}></div>

                    <div className="w-100">
                        <div className="d-flex w-100 justify-content-between">
                            <div className="skeleton-text" style={{ width: '200px', height: '16px' }}></div>
                        </div>
                        <div className="skeleton-text mt-1" style={{ width: '150px', height: '12px' }}></div>
                    </div>

                    <div className="skeleton-switch mx-3" style={{ width: '40px', height: '20px' }}></div>

                    <div className="skeleton-dropdown" style={{ width: '30px', height: '30px' }}></div>
                </div>
            </div>
        ));
    }

    // Calcular usuarios filtrados para mostrar el total actualizado
    const filteredUsersCount = users.filter(u => {
        let matchesSearch = u.name.toLowerCase().includes(searchParam.toLowerCase()) ||
            u.email.toLowerCase().includes(searchParam.toLowerCase());
        if (searchParam && !matchesSearch) return false;

        if (filterAppPassword === 'yes' && !(u.app_password && u.app_password.length > 0)) return false;
        if (filterAppPassword === 'no' && (u.app_password && u.app_password.length > 0)) return false;

        if (filterCampaign === 'yes' && !(u.campaigns && u.campaigns.length > 0)) return false;
        if (filterCampaign === 'no' && (u.campaigns && u.campaigns.length > 0)) return false;

        if (filterPaused === 'yes' && !u.paused) return false;
        if (filterPaused === 'no' && u.paused) return false;

        if (filterRole !== 'all' && u.role !== filterRole) return false;

        return true;
    }).length;

    return (
        <div>
            <style>{skeletonStyles}</style>
            <div className="ulysses-sequences-title d-flex justify-content-between align-items-center">
                <h5 className="bold">Users registered
                    (<small className='text-danger fs-14 mx-1'>{filteredUsersCount} / {users.length}</small>)
                </h5>
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={getUsersRegistered}
                    title="Sync users">
                    <i className="fas fa-sync-alt me-2"></i>
                    Sync
                </button>
            </div>

            <div className="ulysses-sequences-container">
                <div className="ulysses-sequences-body">
                    <div className="ulysses-sequences-buttons d-flex my-2 justify-content-between">
                        <NavLink
                            to={`/admin/users/new`}
                            className='btn btn-primary btn-sm'>
                            <i className="fas fa-user me-2"></i>
                            Create user
                        </NavLink>

                        <input type="text"
                            style={{ width: '200px' }}
                            className='form-control form-control-sm ms-2'
                            value={searchParam}
                            onChange={(e) => setSearchParam(e.target.value)}
                            placeholder='Search user' />

                        <select className='form-select form-select-sm ms-2' style={{ width: '150px' }}
                            value={filterAppPassword}
                            onChange={(e) => setFilterAppPassword(e.target.value)}>
                            <option value='all'>App password</option>
                            <option value='yes'>With password</option>
                            <option value='no'>Without password</option>
                        </select>

                        <select className='form-select form-select-sm ms-2' style={{ width: '150px' }}
                            value={filterCampaign}
                            onChange={(e) => setFilterCampaign(e.target.value)}>
                            <option value='all'>Campaign</option>
                            <option value='yes'>Has campaign</option>
                            <option value='no'>No campaign</option>
                        </select>

                        <select className='form-select form-select-sm ms-2' style={{ width: '150px' }}
                            value={filterPaused}
                            onChange={(e) => setFilterPaused(e.target.value)}>
                            <option value='all'>Paused?</option>
                            <option value='yes'>Paused</option>
                            <option value='no'>Active</option>
                        </select>

                        <Dropdown>
                            <Dropdown.Toggle variant="secondary"
                                className="btn-sm ms-2"
                                style={{ width: '150px' }}
                                id="dropdown-role">
                                {renderRoleDropdownText()}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setFilterRole('all')}>
                                    <i className="fas fa-filter me-2"></i>
                                    User type
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setFilterRole('admin')}>
                                    <i className="fas fa-user-shield text-danger me-2"></i>
                                    Admin
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setFilterRole('user')}>
                                    <i className="fas fa-user text-primary me-2"></i>
                                    User
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setFilterRole('whitelist')}>
                                    <i className="fas fa-user-clock text-warning me-2"></i>
                                    Whitelist
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>


                    <div className="ulysses-sequences-table" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                        {isLoading ? renderSkeletonLoader() : renderUsers()}
                    </div>
                </div>
            </div>
            <Tooltip id="users-registered-tooltip" />
        </div>
    );
}

export default AdminListUsers;
